// tslint:disable: variable-name
import { Favorecido, ManutencaoPatrimonio, Pessoa } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Setor } from '../almoxarifado/setor.model';
import { Usuario } from '../comum/usuario.model';
import { Tombamento } from './tombamento.model';

export class ManutencaoItemPatrimonio extends BaseResourceModel {
    constructor(
        public id?: number,
        public aux?: number,
        public status?: 'PENDENTE' | 'EM ANDAMENTO' | 'CONCLUIDO' | 'EXCLUIDO',
        public manutencao?: ManutencaoPatrimonio,
        public origem?: Setor,
        public tombamento?: Tombamento,
        public responsavel?: Pessoa,
        public favorecido?: Favorecido,
        public usuario?: Usuario
    ) {
        super();
    }

    static converteJson(json: any): ManutencaoItemPatrimonio {
        return Object.assign(new ManutencaoItemPatrimonio(), json);
    }
}
